export default __webpack_public_path__ + "static/media/CircleBlue-cto.9821a6b4.svg";